import { Box, Container, Typography } from '@mui/material';
import { ReactNode } from 'react';

import ScrollToTop from 'components/@navigation/ScrollToTop';

interface Props {
  title?: ReactNode;
  cover?: ReactNode;
  sidebar?: ReactNode;
  children: ReactNode;
}

const PageCustomText = ({ title, cover, sidebar, children }: Props) => {
  return (
    <Box
      sx={{
        color: 'text.primary',
        bgcolor: 'background.default',
      }}
    >
      <Container
        component="section"
        sx={{
          pt: { xs: 4, md: 10 },
          pb: { xs: 8, md: 10 },
        }}
      >
        <Box
          sx={{
            display: { xs: 'flex', md: 'grid' },
            gridTemplateColumns: { md: '7fr 5fr' },
            gap: { md: 16 },
          }}
        >
          <div>
            {title && (
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  mb: { xs: 4, md: 8 },
                }}
              >
                {title}
              </Typography>
            )}
            {cover}
            <Box
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {sidebar}
            </Box>
            {children}
          </div>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
            }}
          >
            {sidebar}
          </Box>
        </Box>
        <ScrollToTop />
      </Container>
    </Box>
  );
};

export default PageCustomText;
